import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadMediaService {
  http = inject(HttpClient);

  getMedia(url: string): Observable<Blob> {
    return this.http.get(`/api/proxy-download-media?url=${encodeURIComponent(url)}`, { 
      responseType: 'blob',
    }).pipe(
      timeout(70000)
    );
  }
}
